import services from 'api/services';
import { logError } from 'global/errors';

import {
  GET_PLAN_REQUEST,
  GET_PLAN_SUCCESS,
  GET_PLAN_FAILURE,
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAILURE,
  CREATE_PAYMENT_REQUEST,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  UPDATE_SUCCESSFUL_TRANSACTION_REQUEST,
  UPDATE_SUCCESSFUL_TRANSACTION_SUCCESS,
  UPDATE_SUCCESSFUL_TRANSACTION_FAILURE,
  UPDATE_FAILED_TRANSACTION_REQUEST,
  UPDATE_FAILED_TRANSACTION_SUCCESS,
  UPDATE_FAILED_TRANSACTION_FAILURE,
} from './constants';

const { ConfigService, CompanyService, PaymentService } = services;

export const getPlan = () => async (dispatch) => {
  try {
    dispatch({ type: GET_PLAN_REQUEST });
    const response = await ConfigService.getPlan();
    dispatch({ type: GET_PLAN_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_PLAN_FAILURE, error: ex.message });
  }
};

export const updateCompany = (companyId, body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_COMPANY_REQUEST });
    const response = await CompanyService.updateCompany(companyId, body);
    dispatch({ type: UPDATE_COMPANY_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_COMPANY_FAILURE, error: ex.message });
  }
};

export const createPayment = (body) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PAYMENT_REQUEST });
    const response = await PaymentService.purchaseTest(body);
    dispatch({ type: CREATE_PAYMENT_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_PAYMENT_FAILURE, error: ex.message });
  }
};

export const updateSuccessfulTransaction = (paymentId, transactionId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_SUCCESSFUL_TRANSACTION_REQUEST });
    const response = await PaymentService.updateSuccessfulTransaction(paymentId, transactionId);
    dispatch({ type: UPDATE_SUCCESSFUL_TRANSACTION_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_SUCCESSFUL_TRANSACTION_FAILURE, error: ex.message });
  }
};

export const updateFailedTransaction = (paymentId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_FAILED_TRANSACTION_REQUEST });
    const response = await PaymentService.updateFailedTransaction(paymentId);
    dispatch({ type: UPDATE_FAILED_TRANSACTION_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_FAILED_TRANSACTION_FAILURE, error: ex.message });
  }
};
